<div class="dunning-action-modal content-block has-padding"
	 [class.block-loader]="(loader.isLoading$ | async) || (loader.isLoading$ | async)">

	<div class="modal-header">
		<h2 class="modal-title dunning-action-{{ (form.valueChanges | async)?.type }}">
			{{
				'Dunning.Actions.ModalPanels.Title.' + (form.value.id ? 'View' : isEditMode ? 'Edit' : 'New') | translate: {
					data: {
						number: form.value.id | charPadderPipe : 8,
						type: form.value.type ? (form.value.type | daType | translate) : ''
					}
				}
			}}
		</h2>
	</div>

	<loader-spinner [model]="formLoader"/>

	<ng-template #mainLoader />

	@if ((loader.neitherLoadingNorError | async) === false) {
		<loader-spinner [model]="loader"/>
	}
	@else {
		@if (dunningAction$ | async; as dunningAction) {
			<ul ngbNav #nav="ngbNav" class="nav-tabs" (activeIdChange)="activeTabId$.next($event)">
				<li ngbNavItem="dunning-action-modal-tab-{{ formPanel }}" [disabled]="navigationDisabled()">
					<a ngbNavLink translate="Dunning.Actions.ModalPanels.Form" [class.opacity-50]="navigationDisabled()"></a>
					<ng-template ngbNavContent>
						<dunning-action-form
							[hasDunningClearanceLevel]="hasDunningClearanceLevel"
							[hasDunningMassActionClearanceLevel]="hasDunningMassActionClearanceLevel"
							[form]="form"
							[isEditMode]="isEditMode"
							(dirtyChanged)="formIsDirty = $event"
						/>
					</ng-template>
				</li>
	
				@if (isEditMode) {
					<li ngbNavItem="dunning-action-modal-tab-{{ commentsPanel }}" [disabled]="navigationDisabled()">
						<a ngbNavLink translate="Dunning.Actions.ModalPanels.Comments"></a>
						<ng-template ngbNavContent>
							<dunning-action-comments
								[hasDunningClearanceLevel]="hasDunningClearanceLevel"
								[loader]="commentsLoader"
								[isDisabled]="form.disabled"
								[comments]="comments$ | async"
								[autocomplete]="notifiableUserNames$ | async"
								(submitNewComment)="onNewComment($event)"
								(changeComment)="onChangeComment($event)"
								(deleteComment)="onDeleteComment($event)"
							/>
						</ng-template>
					</li>
				}
	
				@if ((attachmentTabHidden$ | async) === false) {
					<li ngbNavItem="dunning-action-modal-tab-{{ attachmentsPanel }}" [disabled]="navigationDisabled()">
						<a ngbNavLink translate="Dunning.Actions.ModalPanels.Attachments"></a>
						<ng-template ngbNavContent>
								<dunning-action-attachments-selection
									[withAccountingSelectionHelp]="true"
									[canAddAttachment]="true"
									[canDeleteAttachment]="true"
									[dunningActionId]="dunningAction.id"
									[isDisabled]="form.disabled"
									[loader]="attachmentLoader"
									[attachments]="attachmentList$ | async"
									(addAttachment)="onNewAttachment($event)"
									(selectAttachment)="onSelectDocuments($event)"
									(deleteAttachment)="onDeleteAttachment($event)"
									(unselectAttachment)="onUnselectDocuments($event)"
								/>
						</ng-template>
					</li>
				}
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		}
	}

	<div class="dunning-action-modal-actions form-actions">
		@if (!form.disabled) {
			<button type="button"
				(click)="onCancel()"
				class="btn btn-default"
				translate="Actions.Cancel" data-cy="Cancel"></button>

			<div class="btn-group"
				ngbDropdown
				placement="top-right">
				<button type="button"
					(click)="onSubmit()"
					class="btn btn-primary"
					[disabled]="actionsDisabled()"
					translate="Actions.Save" data-cy="Save"></button>

				<button
					type="button"
					id="button-split"
					[disabled]="!form.valid"
					ngbDropdownToggle data-cy="DropdownToggle"
					class="btn btn-primary dropdown-toggle dropdown-toggle-split">
				</button>

				<div id="dropdown-split"
					ngbDropdownMenu
					class="dropdown-menu">
					<button
						ngbDropdownItem
						class="dropdown-item"
						[disabled]="!form.valid"
						translate="Actions.Achieve" data-cy="Achieve"
						(click)="onSubmit(true)"></button>
				</div>
			</div>
		}
		@else {
			<button type="button"
				(click)="onClose()"
				class="btn btn-primary"
				translate="Actions.Close" data-cy="Close"></button>
		}
	</div>
</div>
